export const SOURCE_LABELS = {
  app: "Мобільний додаток",
  web: "Сайт",
  telegram: "Телеграм",
  viber: "Viber",
};

export const SOURCE_SHORT = {
  app: "APP",
  web: "WEB",
  telegram: "TG",
  viber: "VB",
};

export function sourceLabel(s) {
  return SOURCE_LABELS[s] || s;
}

export function sourceShort(s) {
  return SOURCE_SHORT[s] || (s || "").toUpperCase().slice(0, 3);
}

export function formatTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const now = new Date();
    const sameDay = d.toDateString() === now.toDateString();
    if (sameDay) return d.toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" });
    return d.toLocaleDateString("uk-UA", { day: "2-digit", month: "2-digit" }) +
      " " + d.toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

export function contactDisplay(chat) {
  if (chat.name) return chat.name;
  if (chat.contact_id?.startsWith("visitor_")) return "Анонім " + chat.contact_id.slice(8, 14);
  return chat.contact_id;
}
